// src/components/Logo.js
import React from 'react';
import './Logo.css';

const AppStoreLogo = ({ onClick, className = '', showLabel = true }) => {
  return (
    <div className={`app-store-logo-container ${className}`} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default', display: 'flex', alignItems: 'center', gap: '10px' }} role={onClick ? 'button' : undefined} tabIndex={onClick ? 0 : undefined} onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}>
      <img className="app-store-logo-icon-image" src="/logo-yellow.png" alt="Ivori Logo" style={{ height: '36px', width: 'auto', objectFit: 'contain' }} />
      {showLabel && <span className="app-store-logo-label" style={{ fontWeight: '700', fontSize: '1.4rem' }}>Ivori</span>}
    </div>
  );
};

export default function Logo({ onClick }) {
  return <AppStoreLogo onClick={onClick} />;
}

export function Logo_white({ onClick, showLabel = true }) {
  return <AppStoreLogo onClick={onClick} className="logo-white" showLabel={showLabel} />;
}

/** Icon only, white/inverted for dark backgrounds (e.g. My case apps page) */
export function Logo_white_iconOnly({ onClick }) {
  return <AppStoreLogo onClick={onClick} className="logo-white" showLabel={false} />;
}

export function Logo_black({ onClick, showLabel = true }) {
  return <AppStoreLogo onClick={onClick} className="logo-black" showLabel={showLabel} />;
}

/** Icon only (no "Pathbuddy Apps" text) - for inner app store pages header */
export function Logo_black_iconOnly({ onClick }) {
  return <AppStoreLogo onClick={onClick} className="logo-black" showLabel={false} />;
}